import Vue from 'vue';
import './bootstrap';
import './helper.js';
import './toTop.js';
import 'leaflet/dist/leaflet.css';
import './mobileView';

import './maps/index';

import VueInternationalization from 'vue-i18n';
import Locale from './vue-i18n-locales.generated';

Vue.use(VueInternationalization);

const lang = document.documentElement.lang.substr(0, 2);
const i18n = new VueInternationalization({
    locale: lang,
    messages: Locale,
});

import automaticNetwork from "./airQualityPages/AutomaticNetwork.vue";
import manualNetwork from "./airQualityPages/ManualNetwork.vue";
import epsgram from './modellingPage/Epsgram.vue';
import pbl from './modellingPage/Pbl.vue';
import aod from './modellingPage/Aod.vue';
import cams from './modellingPage/Cams.vue';
import emissionMap from './emissionPage/EmissionMap.vue';
import airPollutionNetwork from './airPollutionPages/AirPollutionNetwork.vue';
import interactiveCharts from "./emissionPage/InteractiveChart.vue";

window.Vue = require('vue');
Vue.prototype.$environment = window.Met.environment;

const app = new Vue({
    el: '#app',
    i18n,
    components: {
      automaticNetwork,
      manualNetwork,
      epsgram,
      pbl,
      aod,
      cams,
      emissionMap,
      airPollutionNetwork,
      interactiveCharts,
    }
});

if (window.Met.slideshows) {
    import('./slideshow');
}
